// extracted by mini-css-extract-plugin
export default {"text":"FormErrorMessage_text__cgtau"};